import { makeStyles } from "@material-ui/core/styles";

export const answerStyles = makeStyles((theme) => ({
  answer: {
    borderRadius: "8px",
    fontWeight: "bold",
    textAlign: "center",
    textTransform: "none",
    width: 200,
    height: 340,
    fontFamily: "Lato",
    border: "#A7BBD4",
    "&:hover": {
      boxShadow: "inset 0px -4px 0px #A7BBD4",
      backgroundColor: "transparent",
      border: "1px solid #A7BBD4",
    },
    [theme.breakpoints.down("sm")]: {
      margin: "-2px",
    },
  },
  selected: {
    backgroundColor: "#E5E5E5",

    "&:hover": {
      boxShadow: "inset 0px -4px 0px #A7BBD4",
      backgroundColor: "#E5E5E5",
    },
  },
  unselected: {
    border: "1px solid black",
    color: "black",
  },
}));
